/* eslint-disable no-nested-ternary */
import { Button, Grid, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  getContractTypes,
  getFormationsMap,
  setAffiliateAction,
} from '@webapps/business';
import {
  ModalSideBar,
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Nodata from 'components/NoData';
import MessageBox from 'components/MessageBox';
import Modal from 'components/Modal';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import { default as ModalLarge } from 'components/ModalLarge';
import ProfilName from 'components/Profil/Components/ProfilName';
import ProfilAffiliate from 'components/Profil/ProfilAffiliate';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import CreateFormation from '../../FormationsCandidats/components/CreateFormation';
import Affiliate from './Affiliate';
import CandidatsCard from './CandidatsCard';
import TransfertDocument from './TransfertDocument';
import Information from 'components/Icons/Information';
import theme from '../theme';

const Candidats = ({
  candidatures,
  totalElements,
  refetchCandidature,
  refetch,
  handleWaitingCount,
  isLoading
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const {
    images: { Affiliate: AffiliateImage }
  } = theme

  const { idUser } = useAuth();
  const intl = useIntl();
  const { push } = useRouter();
  const [openCreateFormation, setOpenCreateFormation] = useState(false);
  const [stepModal, setStepModal] = useState(1);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [idSelect, setIdSelect] = useState(0);
  const [selectedAffiliation, setSelectedAffiliation] = useState();
  const [viewAffiliation, setViewAffiliation] = useState(false);
  const [viewCancelAffiliation, setViewCancelAffiliation] = useState(false);
  const [viewTransfert, setViewTransfert] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [candidatId, setCandidatId] = useState(0);
  const [viewProfil, setViewProfil] = useState(false);
  const { addToast } = useToast();
  const { data: { content: formations = [] } = {} } = useQuery(
    getFormationsMap,
    {
      key: ['formationss', page + idUser + keyword],
      variables: {
        schools: idUser,
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  // const { data: degrees = [] } = useQuery(getDegree, {
  //   key: 'degreeMap',
  // });

  const handleOpenCreateFormation = () => {
    setOpenCreateFormation(true);
  };

  const handleCloseCreateFormation = () => {
    setOpenCreateFormation(false);
  };

  const handleViewCvtheque = () => {
    push(ROUTES_PATH.CVTHEQUE_SCHOOL, { params: { id: idUser } });
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };

  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const handleOpenViewTransfert = () => {
    setViewTransfert(true);
  };
  const handleCloseViewTransfert = () => {
    setViewTransfert(false);
  };

  const viewCV = (id) => {
    setIdSelect(id);
    handleOpenViewProfil();
  };

  const transfert = (item) => {
    setSelectedAffiliation(item);
    handleOpenViewTransfert();
  };

  const handleOpenAffiliation = (item) => {
    setViewAffiliation(true);
    setSelectedAffiliation(item);
  };

  const handleOpenCancelAffiliation = (item) => {
    setViewCancelAffiliation(true);
    setSelectedAffiliation(item);
  };

  const handleCloseAffiliation = () => {
    setViewAffiliation(false);
  };

  const handleCloseCancelAffiliation = () => {
    setViewCancelAffiliation(false);
  };

  useEffect(() => {
    if (candidatures.length && selectedAffiliation) {
      candidatures.map(
        (item) =>
          item?.id === selectedAffiliation?.id && setSelectedAffiliation(item)
      );
    }
  }, [candidatures]);

  const {
    error: errorAffiliateAction,
    isLoading: isLoadingAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(setAffiliateAction);

  const cancelAffiliate = async () => {
    await mutateSetAffiliateAction({
      idAffiliate: selectedAffiliation?.id,
      action: 'cancel',
    });
  };

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Des actions sont nécessaires pour finaliser l'affiliation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: 'Affiliation annulée avec succès',
      });
      handleCloseCancelAffiliation();
      refetchCandidature();
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);

  const filteredCandidatures = candidatures?.filter((item) =>
    ['CREATED', 'ACCEPTED', 'HALF-REJECTED'].includes(item?.status)
  );
  const indexOfLastItem = page * size;
  const indexOfFirstItem = indexOfLastItem - size;
  const currentItems = filteredCandidatures.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  useEffect(() => {
    handleWaitingCount(filteredCandidatures?.length);
  }, [filteredCandidatures]);

  return (
    <Grid item xs>
      <div
        className={css({
          '@media only screen and (max-width: 1023px)': {
            maxHeight: '100%',
          },
          overflow: 'auto',
          height: '100%'
        })}
      >
        {
          isLoading ? (
            <Grid
              container
              className={css({
                padding: spacing(0, 0, 2.5, 2.5),
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
              })}
            >
              {[...Array(size/2)].map((_, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                  <CandidatsCard
                    isLoading={true}
                  />
                </Grid>
              ))}
            </Grid>
          ) : !filteredCandidatures?.length ? (
            <div className={classes.noDataContainer}>
              <Nodata
                image={AffiliateImage}
                contentWidth='70%'
                width="150px"
                padding='0px 20px 20px 0px'
                title="Aucune affiliation en attente"
                description="Les affiliations en attente d'action de votre part ou de celle du candidat apparaîtront ici."
              />
            </div>
          ) : (
            <Grid
              container
              className={css({
                padding: spacing(0, 0, 2.5, 2.5),
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
              })}
            >
              {currentItems?.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <CandidatsCard
                    item={item}
                    cancelAffiliation={() => handleOpenCancelAffiliation(item)}
                    transfertDocument={() => transfert(item)}
                    viewAffiliation={() => handleOpenAffiliation(item)}
                    viewMember={() => viewCV(item?.student?.id)}
                    setOpenMessageBox={setOpenMessageBox}
                    setCandidatId={setCandidatId}
                  />
                </Grid>
              ))}
            </Grid>
          )
        }

        {filteredCandidatures.length > 0 && (
          <PaginationNumbers
            onChange={handlePaginationChange}
            page={page}
            pageCount={size}
            totalCount={filteredCandidatures.length}
          />
        )}
      </div>
      <Modal
        nbStep={5}
        onCancel={handleCloseCreateFormation}
        open={openCreateFormation}
        step={stepModal}
        title={intl.formatMessage({
          id: 'school.formationsCandidats.publierFormation',
        })}
      >
        <div className={classes.text}>
          <div className={css({ display: 'flex', flexDirection: 'row' })}>

            <div>
              <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
            </div>
            <div>
              Permettez aux candidats retrouver votre offre dans “Postuler” et d’y
              candidater en un seul clic.
              <br /> Publier une formation vous permets également de la lier à une
              classe pour obtenir plus de fonctionnalités.
              <br /> Pour en savoir plus, veuillez lire la Base de connaissance.
            </div>
          </div>
        </div>

        <CreateFormation
          onChangeStepModal={setStepModal}
          onClose={handleCloseCreateFormation}
          refetchFormation={refetch}
        />
      </Modal>
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={idSelect} />}
      >
        <ProfilAffiliate id={idSelect} />
      </ModalSideBar>
      <Modal
        onCancel={handleCloseAffiliation}
        open={viewAffiliation}
        subTitle="Finalisez l'affiliation avec votre futur étudiants
        pour l'intégrer dans une classe existante"
        title="Finaliser l'affiliation"
        withStep={false}
      >
        <Affiliate
          affiliation={selectedAffiliation}
          close={handleCloseAffiliation}
          refetchCandidature={refetchCandidature}
        />
      </Modal>
      <Modal
        onCancel={handleCloseViewTransfert}
        open={viewTransfert}
        subTitle="Transferer un document"
        title="Finaliser l'affiliation"
        withStep={false}
      >
        <TransfertDocument
          close={handleCloseViewTransfert}
          data={selectedAffiliation?.additionalFiles}
        />
      </Modal>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={cancelAffiliate}
        isLoading={isLoadingAffiliateAction}
        onClose={handleCloseCancelAffiliation}
        open={viewCancelAffiliation}
        title="Annuler l'affiliation"
      >
        Êtes-vous sûr de vouloir annuler l'affiliation
      </ModalConfirm>
      <Modal
        onCancel={() => setOpenMessageBox(false)}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={candidatId} onCancel={() => setOpenMessageBox(false)} />
      </Modal>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  stepStyles: {
    margin: '10px 0 0 0',
  },
  infoCandidat: { display: 'flex', alignItems: 'center' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  btn: {
    marginBottom: '20px',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F3F7FF',
    borderRadius: 12,
    height: '100%',
  },
});

export default Candidats;
